import { EntityCollectionServiceBase } from '@ngrx/data';
import { map, Observable } from 'rxjs';

export class PlEntityCollectionService<
  T
> extends EntityCollectionServiceBase<T> {
  selectEntityById(uuid: string): Observable<T> {
    return this.entityMap$.pipe(map((entities) => entities[uuid]));
  }

  selectTotalCount(): Observable<number> {
    return this.collection$.pipe(
      map((collection) => (<any>collection).totalRows)
    );
  }
}
